import {useEffect, useState} from "react";
import styles from "components/product/detail/minPrice/MinPrice.module.scss";
import {Button} from "antd";
import InfoIcon from "components/_others/icons/InfoIcon";


export const MinPrice = ({minPriceInLastDays}) => {
    const [isShown, setIsShown] = useState(false)


    return (
        <div className={styles?.minPriceWrapper} onMouseEnter={()=>setIsShown(true)} onMouseLeave={()=> setIsShown(false)}>
            {!isShown?
            <Button type={"ghost"} className={styles.showMinPriceButton}>
                <InfoIcon/>
            </Button>:
            <div className={styles?.minPrice} >
                Najnižšia cena za posledných 30 dní:
                <span className={styles?.minPriceValue}>
                    { ` ${minPriceInLastDays?.priceFormatted}`}
                </span>
            </div>
            }
        </div>
    )
}
